import { render, staticRenderFns } from "./index.vue?vue&type=template&id=36a95fd3&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=36a95fd3&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a95fd3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/MAIS/MAIS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36a95fd3')) {
      api.createRecord('36a95fd3', component.options)
    } else {
      api.reload('36a95fd3', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=36a95fd3&scoped=true", function () {
      api.rerender('36a95fd3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Events/EventDashboard/Grid/index.vue"
export default component.exports